import Metadata from "../components/Metadata"
import { TradingCompanyDetail } from "../types"

interface ICompanyMetadataProps {
  selectedCompany: TradingCompanyDetail
}

type MetadataField = {
  headerName: string
  field: keyof TradingCompanyDetail
  isDate?: boolean
}

const metadataFields: MetadataField[] = [
  { headerName: "Created", field: "created_at", isDate: true },
  { headerName: "Updated", field: "updated_at", isDate: true },
  { headerName: "BB Company", field: "bb_company", isDate: false },
]

/**
 * Shows uneditable company metadata
 */

const CompanyMetadata = ({ selectedCompany }: ICompanyMetadataProps) => (
  <Metadata selectedItem={selectedCompany} metadataFields={metadataFields} />
)

export default CompanyMetadata
